import ManagerRepository from './ManagerRepository';

/**
 * Represents GeneralFactory
 */
abstract class GeneralFactory {
	protected managerRepository: ManagerRepository;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @protected
	 */
	constructor(managerRepository: ManagerRepository) {
		this.managerRepository = managerRepository;
	}
}

export default GeneralFactory;
